import React from 'react';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';

import { AlikeSmartLink } from '../alike-smart-link/index.tsx';
import messages from './messages.tsx';

export const RestrictedIcon = () => {
	const { formatMessage } = useIntl();

	return (
		<LockLockedIcon
			label={formatMessage(messages.restrictedProject)}
			size="small"
			color={token('color.icon.danger')}
		/>
	);
};

export const RestrictedAlikeSmartLink = () => {
	const { formatMessage } = useIntl();

	return (
		<AlikeSmartLink icon={<RestrictedIcon />} content={formatMessage(messages.restrictedProject)} />
	);
};
